var map = {
	"./IMG_0052.jpg": "JZdf",
	"./IMG_0059.jpg": "QedH",
	"./IMG_0066.jpg": "Ayim",
	"./IMG_0070.jpg": "dZpP",
	"./IMG_0084.jpg": "KyOE",
	"./IMG_0085-scaled.jpg": "om95",
	"./IMG_0089.jpg": "NmE4",
	"./IMG_0094.jpg": "cTwL"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y2Jp";